module.exports = __webpack_public_path__ + "static/img/Lable_01.05cd481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lable_01.png
// module id = 1bSE
// module chunks = 1